import React from 'react';
import { Col, Collapse, Row, Spin, Table, Button } from 'antd';

import { useSelector } from "react-redux";
import CustomTypography from "../../common/CustomTypography";
import { MinusOutlined, PlusOutlined } from "@ant-design/icons";
import styles from "./categories.module.scss";
import { TabsEnum } from '../../../utils/Enum/ReportTabsEnum';
import CustomAmountText from '../../common/CustomAmountText';
import { CURRENCY } from '../../../utils/ConstantData';


const CategoriesPage = ({ onClickTabChange = () => { } }) => {
  const {
    categoriesDetails: categoriesData,
  } = useSelector(({ categories }) => categories);
  console.log("categoriesData", categoriesData);

  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <AccordionWithTable onClickTabChange={onClickTabChange} transactionData={categoriesData} />
      </Col>
    </Row>
  );
};

const AccordionWithTable = ({ transactionData, tableProps, onClickTabChange = () => { }, ...restProps }) => {
  const { categoriesLoading: loading, categoriesError: error } = useSelector(({ categories }) => categories);

  const panelStyle = {
    marginBottom: 16,
    background: "white",
    borderRadius: "6px",
    border: "1px solid #C9EEF2",
    color: "#000000E0"
  };

  const formatAmount = (amount) => {
    return new Intl.NumberFormat('en-IN', { style: 'decimal', minimumFractionDigits: 2 }).format(amount);
  };

  const collapseItems = Object.keys(transactionData)?.map((item, index) => {
    const columns = [
      {
        title: 'Category',
        dataIndex: 'category',
        key: 'category',
        className: styles.colStyle,
        width: 190
      },
      {
        title: 'Start date',
        dataIndex: 'startDate',
        key: 'startDate',
        className: styles.colStyle,
        width: 190
      },
      {
        title: 'End date',
        dataIndex: 'endDate',
        key: 'endDate',
        className: styles.colStyle,
        width: 190
      },
      {
        title: `Txn amount (${CURRENCY})`,
        dataIndex: 'amount',
        key: 'amount',
        className: styles.colStyle,
        render: (text) => <CustomAmountText value={text} />,
        width: 190
      },
      {
        title: '% Total txn amount',
        dataIndex: 'exposure',
        key: 'exposure',
        className: styles.colStyle,
        render: (text) => `${text}%`,
        width: 190
      },
      {
        title: `Avg txn amount (${CURRENCY})`,
        dataIndex: 'avgAmount',
        key: 'avgAmount',
        className: styles.colStyle,
        render: (text) => <CustomAmountText value={text} />,
        width: 120
      },
      {
        title: 'Txn count',
        dataIndex: 'transactionCount',
        key: 'transactionCount',
        className: styles.colStyle,
        render: (value, record, index) => {
          return (parseFloat(value) > 0 && transactionData.length - 1 !== index) ? <Button style={{ paddingInline: 4 }} color="primary" variant="link" onClick={() => { onClickTabChange(TabsEnum.TRANSACTION) }}>{value}</Button> : value
        },
        width: 190
      },
    ];

    function countCategories(data) {
      let categoryCount = {};

      data.forEach((item) => {
        if (item.subCategories.length === 0) {
          // Count the category key from the main object
          categoryCount[item.category] = (categoryCount[item.category] || 0) + 1;
        } else {
          // Count the category key from subCategories
          item.subCategories.forEach((subCategory) => {
            categoryCount[subCategory.category] = (categoryCount[subCategory.category] || 0) + 1;
          });
        }
      });

      return categoryCount;
    }

    const getLables = (keyLable) => {
      // Calculating the lengths of subCategories for inflows and outflows
      const result1 = countCategories(transactionData.inflows);
      const result2 = countCategories(transactionData.outflows);


      if (keyLable === 'inflows') {
        console.log("transactionData", JSON.stringify(transactionData))
        return `Inflow Categories (${Object.keys(result1).length})`

        //return `Inflow Categories (${transactionData.inflows.length})`
      } else {
        return `Outflow Categories (${Object.keys(result2).length})`
      }
    }

    // const getExpandDataSource = (keyLable) => {
    //   if(keyLable === 'inflows'){
    //       return transactionData.inflows.subCategories
    //   }else{
    //       return transactionData.outflows.subCategories
    //   }
    // }

    const getDataSource = (keyLable) => {
      if (keyLable === 'inflows') {
        return transactionData.inflows
      } else {
        return transactionData.outflows
      }
    }

    const expandedRowRender = (record) => {
      return (
        <Table
          columns={columns}
          dataSource={record.subCategories}
          pagination={false}
          rowKey={(record) => record.category}
          showHeader={false}
        />
      );
    };

    return {
      key: index.toString(),
      label: <CustomTypography style={{ fontSize: "16px", fontWeight: 500, lineHeight: "24px", color: "#000000E0", fontFamily: "Satoshi" }}>{getLables(item)}</CustomTypography>,
      children: <>
        <Table
          columns={columns}
          dataSource={getDataSource(item)}
          expandable={{
            expandedRowRender: (record) =>
              record.subCategories.length > 0 ? expandedRowRender(record) : null,
            rowExpandable: (record) => record.subCategories.length > 0,
          }}
          rowKey={(record) => record.category}
          pagination={false}
        />
      </>,
      style: panelStyle,
    };
  });


  const IconWrapper = ({ children }) => {
    return (
      <div style={{ height: "16px", width: "16px", borderRadius: "4px", border: "1px solid #F0F0F0", display: "flex", justifyContent: "center" }}>
        {children}
      </div>
    )
  }

  if (loading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "300px" }}>
        <Spin size="large" />
      </div>
    )
  }

  if (error) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "300px", flexDirection: "column" }}>
        <CustomTypography style={{ fontSize: "16px", fontWeight: 500, lineHeight: "24px", color: "#000000E0", fontFamily: "Satoshi" }}>Error fetching data</CustomTypography>
        <CustomTypography type={"paragraph"} style={{ fontSize: "10px", fontWeight: 300, lineHeight: "16px", color: "#000000E0", fontFamily: "Satoshi" }}>{error}</CustomTypography>
      </div>
    )
  }

  return (
    <Collapse
      bordered={false}
      // defaultActiveKey={['0']}
      style={{
        background: "#F7F7FC",
      }}
      // accordion
      items={collapseItems}
      expandIcon={({ isActive }) => <IconWrapper>{isActive ? <MinusOutlined /> : <PlusOutlined />}</IconWrapper>}
      {...restProps}
    />
  )


}

export default CategoriesPage;